var gridLayout = "https://shopfront-cdn.tekoapis.com/static/aae8334388f296cc.svg";

export { gridLayout as default };
